export default "__VITE_PUBLIC_ASSET__08772e06__"